module.exports = __webpack_public_path__ + "static/intertec_screen_3-587b28289167dd96fd69d3de460a87ec.png";